import { X, RotateCcw, Loader2 } from 'lucide-react'
import { useIsMobile } from '@/hooks/useIsMobile'
import BottomSheet from '@/components/Common/BottomSheet'

export default function IndicatorConfigModal({ title, children, onClose, onReset, isOpen, loading }) {
  const isMobile = useIsMobile()
  if (!isOpen) return null

  // En pantalla estrecha (<768px) el panel lateral/centrado es inusable:
  // se convierte en bottom sheet con handle, drag-to-dismiss y max 90dvh.
  if (isMobile) {
    return (
      <BottomSheet
        title={title}
        onClose={onClose}
        loading={loading}
        headerExtra={onReset && (
          <button
            onClick={onReset}
            className="p-2.5 -m-1 text-slate-400 hover:text-slate-600 dark:hover:text-gray-300 rounded-lg transition-colors min-w-[40px] min-h-[40px] flex items-center justify-center"
            title="Restaurar valores por defecto"
          >
            <RotateCcw size={15} />
          </button>
        )}
      >
        <div className="px-4 py-4 space-y-4">
          {children}
        </div>
        <div className="flex justify-end px-4 py-3 border-t border-slate-100 dark:border-gray-700/60">
          <button
            onClick={onClose}
            className="px-4 py-2.5 min-h-[44px] text-xs font-medium rounded-lg bg-blue-600 hover:bg-blue-700 text-white transition-colors"
          >
            Cerrar
          </button>
        </div>
      </BottomSheet>
    )
  }

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 backdrop-blur-sm p-4">
      <div className="w-full max-w-sm bg-white dark:bg-gray-800 rounded-xl shadow-2xl border border-slate-200 dark:border-gray-700 overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b border-slate-100 dark:border-gray-700/60">
          <h3 className="text-sm font-semibold text-slate-800 dark:text-gray-100 flex items-center gap-2">
            {title}
            {loading && (
              <Loader2 size={13} className="animate-spin text-blue-500" title="Calculando…" />
            )}
          </h3>
          <div className="flex items-center gap-1">
            {onReset && (
              <button
                onClick={onReset}
                className="p-1.5 text-slate-400 hover:text-slate-600 dark:hover:text-gray-300 hover:bg-slate-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
                title="Restaurar valores por defecto"
              >
                <RotateCcw size={14} />
              </button>
            )}
            <button
              onClick={onClose}
              className="p-1.5 text-slate-400 hover:text-slate-600 dark:hover:text-gray-300 hover:bg-slate-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
            >
              <X size={16} />
            </button>
          </div>
        </div>

        {/* Body */}
        <div className="px-4 py-4 space-y-4 max-h-[70vh] overflow-y-auto">
          {children}
        </div>

        {/* Footer */}
        <div className="flex justify-end px-4 py-3 border-t border-slate-100 dark:border-gray-700/60 bg-slate-50 dark:bg-gray-750">
          <button
            onClick={onClose}
            className="px-4 py-1.5 text-xs font-medium rounded-lg bg-blue-600 hover:bg-blue-700 text-white transition-colors"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  )
}
